// ** Icons Import
import { Icon } from '@iconify/react/dist/iconify.js';
import { Circle } from 'react-feather';

export default [
    {
        id: 'stock',
        title: 'Stock',
        icon: <Icon icon="ant-design:stock-outlined" height={20} width={20} />,
        children: [
            {
                id: 'stockIn',
                title: 'Stock In',
                icon: <Circle size={20} />,
                navLink: '/stock/stock-in'
            }
        ]
    }
];
